import { filesize } from 'filesize';

/** A size in bytes as the machines' df and KubeSolo's release page show it, e.g. 238 MB. */
export function formatSize(bytes: number) {
  return filesize(bytes, { base: 10, round: 0 });
}
